(function () {
  'use strict';

  var STORAGE_KEY = 'entrevoltas-recently-viewed-v1';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var MAX_HISTORY = 20;

  function clampNumber(value, min, max, fallback) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    return Math.min(max, Math.max(min, Math.round(parsed)));
  }

  function safeParseJson(text) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function normalizeRoot() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') {
      root = window.Shopify.routes.root || '/';
    }
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function normalizeUrl(url, handle) {
    if (typeof url === 'string' && url.trim()) return url;
    return normalizeRoot() + 'products/' + encodeURIComponent(handle || '');
  }

  function isValidStoredItem(item, now) {
    if (!item || typeof item !== 'object') return false;
    if (typeof item.handle !== 'string' || !item.handle.trim()) return false;
    if (typeof item.title !== 'string' || !item.title.trim()) return false;
    if (typeof item.url !== 'string' || !item.url.trim()) return false;
    if (!Number.isFinite(Number(item.viewed_at))) return false;
    if (Number(item.viewed_at) > now + 60000) return false;
    if (now - Number(item.viewed_at) > TTL_MS) return false;
    return true;
  }

  function sanitizeHistory(raw, now, limit) {
    if (!Array.isArray(raw)) return [];
    var items = raw
      .filter(function (item) { return isValidStoredItem(item, now); })
      .sort(function (a, b) { return Number(b.viewed_at) - Number(a.viewed_at); });

    var seen = new Set();
    var clean = [];
    items.forEach(function (item) {
      var handle = item.handle.trim();
      if (seen.has(handle)) return;
      seen.add(handle);
      clean.push({
        id: item.id,
        handle: handle,
        url: normalizeUrl(item.url, handle),
        title: item.title,
        image: typeof item.image === 'string' ? item.image : '',
        image_alt: typeof item.image_alt === 'string' && item.image_alt ? item.image_alt : item.title,
        price: Number(item.price) || 0,
        compare_at_price: Number(item.compare_at_price) || 0,
        price_varies: Boolean(item.price_varies),
        available: item.available !== false,
        viewed_at: Number(item.viewed_at)
      });
    });
    return clean.slice(0, Math.min(limit, MAX_HISTORY));
  }

  function readHistory(limit) {
    var now = Date.now();
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? safeParseJson(raw) : [];
      return {
        available: true,
        items: sanitizeHistory(parsed, now, limit)
      };
    } catch (error) {
      return { available: false, items: [] };
    }
  }

  async function refreshHistoryPrices(items) {
    if (!Array.isArray(items) || !items.length) return items;

    var root = normalizeRoot();
    return Promise.all(items.map(async function (item) {
      if (!item.handle) return item;
      try {
        var response = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js', {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return item;
        var live = mapRecommendation(await response.json());
        return live ? Object.assign({}, item, live, { viewed_at: item.viewed_at }) : item;
      } catch (error) {
        return item;
      }
    }));
  }

  function writeHistory(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (error) {
      return false;
    }
  }

  function parseCurrentProduct(section) {
    var node = section.querySelector('[data-ev-current-product]');
    if (!node) return null;
    var current = safeParseJson(node.textContent || '');
    if (!current || typeof current !== 'object') return null;
    if (typeof current.handle !== 'string' || !current.handle) return null;
    if (typeof current.title !== 'string' || !current.title) return null;
    return {
      id: current.id,
      handle: current.handle,
      url: normalizeUrl(current.url, current.handle),
      title: current.title,
      image: typeof current.image === 'string' ? current.image : '',
      image_alt: typeof current.image_alt === 'string' && current.image_alt ? current.image_alt : current.title,
      price: Number(current.price) || 0,
      compare_at_price: Number(current.compare_at_price) || 0,
      price_varies: Boolean(current.price_varies),
      available: current.available !== false
    };
  }

  function currentForStorage(current, now) {
    return {
      id: current.id,
      handle: current.handle,
      url: current.url,
      title: current.title,
      image: current.image,
      image_alt: current.image_alt,
      price: current.price,
      compare_at_price: current.compare_at_price,
      price_varies: current.price_varies,
      available: current.available,
      viewed_at: now
    };
  }

  function mapRecommendation(product) {
    if (!product || typeof product !== 'object') return null;
    var handle = typeof product.handle === 'string' ? product.handle : '';
    if (!handle) return null;

    var featured = product.featured_image;
    var image = '';
    var imageAlt = product.title || '';
    if (typeof featured === 'string') {
      image = featured;
    } else if (featured && typeof featured === 'object') {
      image = featured.url || featured.src || '';
      imageAlt = featured.alt || imageAlt;
    }
    if (!image && Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === 'string') image = product.images[0];
      else if (product.images[0] && typeof product.images[0] === 'object') image = product.images[0].src || product.images[0].url || '';
    }

    return {
      id: product.id,
      handle: handle,
      url: normalizeUrl(product.url, handle),
      title: product.title || handle,
      image: image,
      image_alt: imageAlt || product.title || handle,
      price: Number(product.price) || 0,
      compare_at_price: Number(product.compare_at_price || product.compare_at_price_max) || 0,
      price_varies: Boolean(product.price_varies),
      available: product.available !== false
    };
  }

  async function fetchRecommendations(current, recentItems, needed) {
    if (needed <= 0) return [];
    var root = normalizeRoot();
    var endpoint = root + 'recommendations/products.json?product_id=' +
      encodeURIComponent(current.id) + '&limit=10&intent=related';

    var response = await fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Recommendation request failed');

    var payload = await response.json();
    var products = payload && Array.isArray(payload.products) ? payload.products : [];
    var blocked = new Set([current.handle]);
    recentItems.forEach(function (item) { blocked.add(item.handle); });

    var chosen = [];
    products.forEach(function (product) {
      if (chosen.length >= needed) return;
      var mapped = mapRecommendation(product);
      if (!mapped || blocked.has(mapped.handle)) return;
      blocked.add(mapped.handle);
      chosen.push(mapped);
    });
    return chosen;
  }

  function formatMoney(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(value);
      } catch (error) {
        // Fall through to Intl.
      }
    }

    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value / 100);
    } catch (error) {
      return 'R$ ' + (value / 100).toFixed(2).replace('.', ',');
    }
  }

  function createElement(tag, className) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    return element;
  }

  function parseDisplayTitle(fullTitle) {
    var raw = String(fullTitle || '').trim();
    if (!raw) return { stamp: '', model: '' };

    var normalized = raw
      .replace(/ — /g, ' - ')
      .replace(/ – /g, ' - ');
    var parts = normalized.split(' - ');

    if (parts.length < 2) return { stamp: raw, model: '' };

    var model = String(parts.shift() || '').trim();
    var stamp = parts.join(' - ').trim();

    if (!stamp) return { stamp: raw, model: '' };
    return { stamp: stamp, model: model };
  }

  function buildCard(item, suggestion, splitTitle) {
    var li = createElement('div', 'ev-recent-shelf__item');
    li.setAttribute('role', 'listitem');

    var article = createElement('article', 'ev-recent-shelf__card');

    var imageLink = createElement('a', 'ev-recent-shelf__image-link');
    imageLink.href = item.url;
    imageLink.setAttribute('aria-label', item.title);

    var frame = createElement('div', 'ev-recent-shelf__image-frame');
    if (item.image) {
      var img = createElement('img', 'ev-recent-shelf__image');
      img.src = item.image;
      img.alt = item.image_alt || item.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      frame.appendChild(img);
    }
    imageLink.appendChild(frame);
    article.appendChild(imageLink);

    var meta = createElement('div', 'ev-recent-shelf__meta');

    if (suggestion) {
      var suggestionLabel = createElement('span', 'ev-recent-shelf__suggestion');
      suggestionLabel.textContent = 'Sugestão';
      meta.appendChild(suggestionLabel);
    }

    var title = createElement('h3', 'ev-recent-shelf__title');
    var titleLink = createElement('a', 'ev-recent-shelf__title-link');
    titleLink.href = item.url;
    titleLink.setAttribute('aria-label', item.title);

    if (splitTitle) {
      var parsedTitle = parseDisplayTitle(item.title);
      var stamp = createElement('span', 'ev-recent-shelf__stamp');
      stamp.setAttribute('aria-hidden', 'true');
      stamp.textContent = parsedTitle.stamp || item.title;
      titleLink.appendChild(stamp);

      if (parsedTitle.model) {
        var model = createElement('span', 'ev-recent-shelf__model');
        model.setAttribute('aria-hidden', 'true');
        model.textContent = parsedTitle.model;
        titleLink.appendChild(model);
      }

      var fullTitle = createElement('span', 'visually-hidden');
      fullTitle.textContent = item.title;
      titleLink.appendChild(fullTitle);
    } else {
      titleLink.textContent = item.title;
    }

    title.appendChild(titleLink);
    meta.appendChild(title);

    var priceWrap = createElement('div', 'ev-recent-shelf__price');
    var currentPrice = createElement('span', 'ev-recent-shelf__price-current');
    currentPrice.textContent = (item.price_varies ? 'A partir de ' : '') + formatMoney(item.price);
    priceWrap.appendChild(currentPrice);

    if (Number(item.compare_at_price) > Number(item.price)) {
      var compare = createElement('span', 'ev-recent-shelf__price-compare');
      compare.textContent = formatMoney(item.compare_at_price);
      priceWrap.appendChild(compare);

      var discount = Math.round((1 - Number(item.price) / Number(item.compare_at_price)) * 100);
      if (Number.isFinite(discount) && discount > 0) {
        var badge = createElement('span', 'badge badge-custom lm-badge-desktop ev-card-sale-badge');
        badge.textContent = discount + '% OFF';
                badge.style.backgroundColor = '#D65A38';
                        badge.style.borderColor = '#D65A38';
                                badge.style.color = '#F2EFE7';
        priceWrap.appendChild(badge);
      }
    }
    meta.appendChild(priceWrap);

    article.appendChild(meta);
    li.appendChild(article);
    return li;
  }

  function updateControls(section) {
    var rail = section.querySelector('[data-ev-rail]');
    var controls = section.querySelector('[data-ev-controls]');
    var prev = section.querySelector('[data-ev-prev]');
    var next = section.querySelector('[data-ev-next]');
    if (!rail || !controls || !prev || !next) return;

    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    var hasOverflow = maxScroll > 2;
    controls.hidden = !hasOverflow;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= maxScroll - 2;
  }

  function bindNavigation(section) {
    var rail = section.querySelector('[data-ev-rail]');
    var prev = section.querySelector('[data-ev-prev]');
    var next = section.querySelector('[data-ev-next]');
    if (!rail || !prev || !next) return;

    function amount() {
      return Math.max(rail.clientWidth * 0.88, 240);
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -amount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: amount(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', function () { updateControls(section); }, { passive: true });
    window.addEventListener('resize', function () { updateControls(section); }, { passive: true });
  }

  function renderShelf(section, recentItems, recommendations) {
    var rail = section.querySelector('[data-ev-rail]');
    var heading = section.querySelector('.ev-recent-shelf__heading');
    if (!rail || !heading) return;

    rail.textContent = '';
    var hasRecent = recentItems.length > 0;
    heading.textContent = hasRecent
      ? (section.dataset.headingRecent || 'Vistos recentemente')
      : (section.dataset.headingFallback || 'Explore também');

    var splitTitles = section.dataset.evShelfContext === 'home' || section.dataset.evShelfContext === 'product';

    recentItems.forEach(function (item) {
      rail.appendChild(buildCard(item, false, splitTitles));
    });

    recommendations.forEach(function (item) {
      rail.appendChild(buildCard(item, hasRecent, splitTitles));
    });

    if (!rail.children.length) {
      section.hidden = true;
      return;
    }

    section.hidden = false;
    window.requestAnimationFrame(function () { updateControls(section); });
  }

  function parseHomeFallback(section) {
    var node = section.querySelector('[data-ev-home-fallback-products]');
    if (!node) return [];
    var parsed = safeParseJson(node.textContent || '');
    if (!Array.isArray(parsed)) return [];

    var seen = new Set();
    var clean = [];
    parsed.forEach(function (item) {
      if (!item || typeof item !== 'object') return;
      var handle = typeof item.handle === 'string' ? item.handle.trim() : '';
      var title = typeof item.title === 'string' ? item.title.trim() : '';
      if (!handle || !title || seen.has(handle)) return;
      seen.add(handle);
      clean.push({
        id: item.id,
        handle: handle,
        url: normalizeUrl(item.url, handle),
        title: title,
        image: typeof item.image === 'string' ? item.image : '',
        image_alt: typeof item.image_alt === 'string' && item.image_alt ? item.image_alt : title,
        price: Number(item.price) || 0,
        compare_at_price: Number(item.compare_at_price) || 0,
        price_varies: Boolean(item.price_varies),
        available: item.available !== false
      });
    });
    return clean;
  }

  function selectHomeFallback(fallbackItems, recentItems, needed) {
    if (needed <= 0) return [];
    var blocked = new Set();
    recentItems.forEach(function (item) { blocked.add(item.handle); });
    var chosen = [];
    fallbackItems.forEach(function (item) {
      if (chosen.length >= needed || blocked.has(item.handle)) return;
      blocked.add(item.handle);
      chosen.push(item);
    });
    return chosen;
  }

  async function initProductSection(section, historyLimit, minimumItems) {
    var current = parseCurrentProduct(section);
    if (!current) return;

    var historyState = readHistory(historyLimit);
    var prior = historyState.items
      .filter(function (item) { return item.handle !== current.handle; })
      .sort(function (a, b) { return Number(b.viewed_at) - Number(a.viewed_at); })
      .slice(0, historyLimit);

    var recentItems = await refreshHistoryPrices(prior.slice(0, historyLimit));

    if (historyState.available) {
      var nextHistory = [currentForStorage(current, Date.now())]
        .concat(recentItems)
        .slice(0, historyLimit);
      writeHistory(nextHistory);
    }
    var needed = Math.max(0, minimumItems - recentItems.length);
    var recommendations = [];

    if (needed > 0) {
      try {
        recommendations = await fetchRecommendations(current, recentItems, needed);
      } catch (error) {
        recommendations = [];
      }
    }

    renderShelf(section, recentItems, recommendations);
    bindNavigation(section);
  }

  async function initHomeSection(section, historyLimit, minimumItems) {
    var historyState = readHistory(historyLimit);
    var recentItems = await refreshHistoryPrices(historyState.items
      .sort(function (a, b) { return Number(b.viewed_at) - Number(a.viewed_at); })
      .slice(0, historyLimit));

    if (historyState.available) writeHistory(recentItems);

    var needed = Math.max(0, minimumItems - recentItems.length);
    var fallbackItems = parseHomeFallback(section);
    var recommendations = selectHomeFallback(fallbackItems, recentItems, needed);

    renderShelf(section, recentItems, recommendations);
    bindNavigation(section);
  }

  async function initSection(section) {
    if (!section || section.dataset.evInitialized === 'true') return;
    section.dataset.evInitialized = 'true';

    var context = section.dataset.evShelfContext || 'generic';
    var historyLimit = clampNumber(section.dataset.historyLimit, 1, MAX_HISTORY, MAX_HISTORY);
    var minimumItems = clampNumber(section.dataset.minimumItems, 1, 4, 4);

    if (context === 'product') {
      await initProductSection(section, historyLimit, minimumItems);
      return;
    }

    if (context === 'home') {
      await initHomeSection(section, historyLimit, minimumItems);
      return;
    }

    section.hidden = true;
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ev-recent-shelf]').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
